module.exports = __webpack_public_path__ + "static/media/kaci-baum-2.d1020217.jpg";